import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent, Register } from '@xanadu/core';
import { Group } from '@xanadu/model';

@Component({
    selector: 'app-group-panel',
    templateUrl: './group-panel.component.html',
    styleUrls: ['./group-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('group-panel')
export class GroupPanelComponent extends PanelComponent<Group> {
    private tabGroup = { caption: 'Group', active: true, hidden: false };

    protected override get nodeType(): string | undefined {
        return 'user';
    }

    protected override setup(group: Group): void {
        super.setup(group);

        this.tabs = [
            this.tabGroup
        ];
        this.tabSelected = this.tabGroup;
    }
}
